import State from './state';

const icons = {
    FITTING: {
        label    : 'ovalTbug.png',
        pin      : 'pinFE.png',
        pin_event: 'pinFE.png'
    },
    REYNOLDS: {
        label    : 'ovalRP.png',
        pin      : 'pinRP.png',
        event_pin: null
    },
    CERT: {
        label    : 'ovalCertified.png',
        pin      : 'pinCertified.png',
        event_pin: 'pinCertifiedEvent.png'
    },
    PREM: {
        label    : 'ovalPre.png',
        pin      : 'pinPre.png',
        event_pin: 'pinPreEvent.png'
    },
    CORE: {
        label    : 'ovalCore.png',
        pin      : 'pinCore.png',
        event_pin: 'pinCoreEvent.png'
    },
    TMPL: {
        label    : 'oval-PL.png',
        pin      : 'Tag_PL.png',
        event_pin: 'Tag_PL_MFE.png'
    },
    TMPS: {
        label    : 'oval-PS.png',
        pin      : 'Tag_PS.png',
        event_pin: 'Tag_PS_MFE.png'
    },
    TMPC: {
        label    : 'oval-PC.png',
        pin      : 'Tag_PC.png',
        event_pin: 'Tag_PC_MFE.png'
    },
    SELECT: {
        label    : 'oval-SF.png',
        pin      : 'Tag_SF.png',
        event_pin: 'Tag_SF_MFE.png'
    },
    RETAIL: {
        label    : 'ovalRetail.png',
        pin      : 'pinRetail.png',
        event_pin: 'pinRetailevent.png'
    },
    NFC: {
        label: 'ovalNFC.png'
    },
    AMBASSADOR: {
        label: 'ovalAmbassador.jpg?$staticlink$'
    }
};

export default {
    getPath (type, purpose) {
        return (State.imagePath).replace('__FILE__', icons[type][purpose]);
    }
};
